/**
 * ATTENTION! This file is auto-generated for the 'crm' module.
 * Vite plugin placed is here: packages/platform/server/rpc-generator/generator.ts
 * Any manual changes will be overwritten on the next build.
*/

import { makeRepositoryProxy } from '@ayocore/platform/server/rpc/makeRepositoryProxy';
import { makeFunctionProxy } from '@ayocore/platform/server/rpc/makeFunctionProxy';
import type { RpcFunctionClient } from '@ayocore/platform/server/rpc/types';
import type { PartnerRepository } from '../server/repositories/PartnerRepository';
import type { PartnerRoleRepository } from '../server/repositories/PartnerRoleRepository';
import type { PartnerRoleAttributeRepository } from '../server/repositories/PartnerRoleAttributeRepository';
import type { PartnerRoleAttributeOptionRepository } from '../server/repositories/PartnerRoleAttributeOptionRepository';
import type { PartnerAttributeValueRepository } from '../server/repositories/PartnerAttributeValueRepository';
import type { PartnerExternalAccountRepository } from '../server/repositories/PartnerExternalAccountRepository';
import type { SuppliersRepository } from '../server/repositories/SuppliersRepository';
import type { ContactPersonRepository } from '../server/repositories/ContactPersonRepository';
import type { ContactChannelRepository } from '../server/repositories/ContactChannelRepository';
import type { LeadRepository } from '../server/repositories/LeadRepository';
import type { LeadReportRepository } from '../server/repositories/LeadReportRepository';
import type { LeadVersionRepository } from '../server/repositories/LeadVersionRepository';
import type { LeadRowRepository } from '../server/repositories/LeadRowRepository';
import type { LeadRowQuoteRepository } from '../server/repositories/LeadRowQuoteRepository';
import type { LeadStatusRepository } from '../server/repositories/LeadStatusRepository';
import type { LeadStatusTransitionRepository } from '../server/repositories/LeadStatusTransitionRepository';
import type { LeadTypeRepository } from '../server/repositories/LeadTypeRepository';
import type { LeadEventRepository } from '../server/repositories/LeadEventRepository';
import type { PartnerEventRepository } from '../server/repositories/PartnerEventRepository';
import type { DealRepository } from '../server/repositories/DealRepository';
import type { DealReportRepository } from '../server/repositories/DealReportRepository';
import type { PartnerReportRepository } from '../server/repositories/PartnerReportRepository';
import type { PartnerDuplicatesRepository } from '../server/repositories/PartnerDuplicatesRepository';
import type { ManagerReportRepository } from '../server/repositories/ManagerReportRepository';
import type { DealTypeRepository } from '../server/repositories/DealTypeRepository';
import type { DealStatusRepository } from '../server/repositories/DealStatusRepository';
import type { DealVersionRepository } from '../server/repositories/DealVersionRepository';
import type { DealRowRepository } from '../server/repositories/DealRowRepository';
import type { DealRowQuoteRepository } from '../server/repositories/DealRowQuoteRepository';
import type { WorkOrderRepository } from '../server/repositories/WorkOrderRepository';
import type { DealEventRepository } from '../server/repositories/DealEventRepository';
import type { SalesAreaRepository } from '../server/repositories/SalesAreaRepository';
import type { SegmentRepository } from '../server/repositories/SegmentRepository';
import type { TagRepository } from '../server/repositories/TagRepository';
import type { SalesPlanRepository } from '../server/repositories/SalesPlanRepository';
import type { SalesPlanItemRepository } from '../server/repositories/SalesPlanItemRepository';
import type { DealTypeAttributeRepository } from '../server/repositories/DealTypeAttributeRepository';
import type { DealTypeAttributeOptionRepository } from '../server/repositories/DealTypeAttributeOptionRepository';
import type { DealAttributeValueRepository } from '../server/repositories/DealAttributeValueRepository';
import type { LeadTypeAttributeRepository } from '../server/repositories/LeadTypeAttributeRepository';
import type { LeadTypeAttributeOptionRepository } from '../server/repositories/LeadTypeAttributeOptionRepository';
import type { LeadAttributeValueRepository } from '../server/repositories/LeadAttributeValueRepository';
import type { PartnerStatusRepository } from '../server/repositories/PartnerStatusRepository';
import type { LeadSourceRepository } from '../server/repositories/LeadSourceRepository';
import type { LostReasonRepository } from '../server/repositories/LostReasonRepository';
import type { CrmTaskRepository } from '../server/repositories/CrmTaskRepository';

// Terminal methods configuration
const TERMINAL_METHODS = ["create","update","findById","deleteById","fetch","count","aggregate","aggregateBy","countGroups","meta","getInstance","columns","filters"];

type PartnerRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<PartnerRepository>;
export function usePartnerRepository(): PartnerRepositoryClient { return makeRepositoryProxy<PartnerRepositoryClient>('crm::PartnerRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте usePartnerRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const partnerRepository = usePartnerRepository();

type PartnerRoleRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<PartnerRoleRepository>;
export function usePartnerRoleRepository(): PartnerRoleRepositoryClient { return makeRepositoryProxy<PartnerRoleRepositoryClient>('crm::PartnerRoleRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте usePartnerRoleRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const partnerRoleRepository = usePartnerRoleRepository();

type PartnerRoleAttributeRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<PartnerRoleAttributeRepository>;
export function usePartnerRoleAttributeRepository(): PartnerRoleAttributeRepositoryClient { return makeRepositoryProxy<PartnerRoleAttributeRepositoryClient>('crm::PartnerRoleAttributeRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте usePartnerRoleAttributeRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const partnerRoleAttributeRepository = usePartnerRoleAttributeRepository();

type PartnerRoleAttributeOptionRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<PartnerRoleAttributeOptionRepository>;
export function usePartnerRoleAttributeOptionRepository(): PartnerRoleAttributeOptionRepositoryClient { return makeRepositoryProxy<PartnerRoleAttributeOptionRepositoryClient>('crm::PartnerRoleAttributeOptionRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте usePartnerRoleAttributeOptionRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const partnerRoleAttributeOptionRepository = usePartnerRoleAttributeOptionRepository();

type PartnerAttributeValueRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<PartnerAttributeValueRepository>;
export function usePartnerAttributeValueRepository(): PartnerAttributeValueRepositoryClient { return makeRepositoryProxy<PartnerAttributeValueRepositoryClient>('crm::PartnerAttributeValueRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте usePartnerAttributeValueRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const partnerAttributeValueRepository = usePartnerAttributeValueRepository();

type PartnerExternalAccountRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<PartnerExternalAccountRepository>;
export function usePartnerExternalAccountRepository(): PartnerExternalAccountRepositoryClient { return makeRepositoryProxy<PartnerExternalAccountRepositoryClient>('crm::PartnerExternalAccountRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте usePartnerExternalAccountRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const partnerExternalAccountRepository = usePartnerExternalAccountRepository();

type SuppliersRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<SuppliersRepository>;
export function useSuppliersRepository(): SuppliersRepositoryClient { return makeRepositoryProxy<SuppliersRepositoryClient>('crm::SuppliersRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useSuppliersRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const suppliersRepository = useSuppliersRepository();

type ContactPersonRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ContactPersonRepository>;
export function useContactPersonRepository(): ContactPersonRepositoryClient { return makeRepositoryProxy<ContactPersonRepositoryClient>('crm::ContactPersonRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useContactPersonRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const contactPersonRepository = useContactPersonRepository();

type ContactChannelRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ContactChannelRepository>;
export function useContactChannelRepository(): ContactChannelRepositoryClient { return makeRepositoryProxy<ContactChannelRepositoryClient>('crm::ContactChannelRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useContactChannelRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const contactChannelRepository = useContactChannelRepository();

type LeadRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<LeadRepository>;
export function useLeadRepository(): LeadRepositoryClient { return makeRepositoryProxy<LeadRepositoryClient>('crm::LeadRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useLeadRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const leadRepository = useLeadRepository();

type LeadReportRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<LeadReportRepository>;
export function useLeadReportRepository(): LeadReportRepositoryClient { return makeRepositoryProxy<LeadReportRepositoryClient>('crm::LeadReportRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useLeadReportRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const leadReportRepository = useLeadReportRepository();

type LeadVersionRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<LeadVersionRepository>;
export function useLeadVersionRepository(): LeadVersionRepositoryClient { return makeRepositoryProxy<LeadVersionRepositoryClient>('crm::LeadVersionRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useLeadVersionRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const leadVersionRepository = useLeadVersionRepository();

type LeadRowRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<LeadRowRepository>;
export function useLeadRowRepository(): LeadRowRepositoryClient { return makeRepositoryProxy<LeadRowRepositoryClient>('crm::LeadRowRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useLeadRowRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const leadRowRepository = useLeadRowRepository();

type LeadRowQuoteRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<LeadRowQuoteRepository>;
export function useLeadRowQuoteRepository(): LeadRowQuoteRepositoryClient { return makeRepositoryProxy<LeadRowQuoteRepositoryClient>('crm::LeadRowQuoteRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useLeadRowQuoteRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const leadRowQuoteRepository = useLeadRowQuoteRepository();

type LeadStatusRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<LeadStatusRepository>;
export function useLeadStatusRepository(): LeadStatusRepositoryClient { return makeRepositoryProxy<LeadStatusRepositoryClient>('crm::LeadStatusRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useLeadStatusRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const leadStatusRepository = useLeadStatusRepository();

type LeadStatusTransitionRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<LeadStatusTransitionRepository>;
export function useLeadStatusTransitionRepository(): LeadStatusTransitionRepositoryClient { return makeRepositoryProxy<LeadStatusTransitionRepositoryClient>('crm::LeadStatusTransitionRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useLeadStatusTransitionRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const leadStatusTransitionRepository = useLeadStatusTransitionRepository();

type LeadTypeRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<LeadTypeRepository>;
export function useLeadTypeRepository(): LeadTypeRepositoryClient { return makeRepositoryProxy<LeadTypeRepositoryClient>('crm::LeadTypeRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useLeadTypeRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const leadTypeRepository = useLeadTypeRepository();

type LeadEventRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<LeadEventRepository>;
export function useLeadEventRepository(): LeadEventRepositoryClient { return makeRepositoryProxy<LeadEventRepositoryClient>('crm::LeadEventRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useLeadEventRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const leadEventRepository = useLeadEventRepository();

type PartnerEventRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<PartnerEventRepository>;
export function usePartnerEventRepository(): PartnerEventRepositoryClient { return makeRepositoryProxy<PartnerEventRepositoryClient>('crm::PartnerEventRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте usePartnerEventRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const partnerEventRepository = usePartnerEventRepository();

type DealRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<DealRepository>;
export function useDealRepository(): DealRepositoryClient { return makeRepositoryProxy<DealRepositoryClient>('crm::DealRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useDealRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const dealRepository = useDealRepository();

type DealReportRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<DealReportRepository>;
export function useDealReportRepository(): DealReportRepositoryClient { return makeRepositoryProxy<DealReportRepositoryClient>('crm::DealReportRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useDealReportRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const dealReportRepository = useDealReportRepository();

type PartnerReportRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<PartnerReportRepository>;
export function usePartnerReportRepository(): PartnerReportRepositoryClient { return makeRepositoryProxy<PartnerReportRepositoryClient>('crm::PartnerReportRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте usePartnerReportRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const partnerReportRepository = usePartnerReportRepository();

type PartnerDuplicatesRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<PartnerDuplicatesRepository>;
export function usePartnerDuplicatesRepository(): PartnerDuplicatesRepositoryClient { return makeRepositoryProxy<PartnerDuplicatesRepositoryClient>('crm::PartnerDuplicatesRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте usePartnerDuplicatesRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const partnerDuplicatesRepository = usePartnerDuplicatesRepository();

type ManagerReportRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ManagerReportRepository>;
export function useManagerReportRepository(): ManagerReportRepositoryClient { return makeRepositoryProxy<ManagerReportRepositoryClient>('crm::ManagerReportRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useManagerReportRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const managerReportRepository = useManagerReportRepository();

type DealTypeRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<DealTypeRepository>;
export function useDealTypeRepository(): DealTypeRepositoryClient { return makeRepositoryProxy<DealTypeRepositoryClient>('crm::DealTypeRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useDealTypeRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const dealTypeRepository = useDealTypeRepository();

type DealStatusRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<DealStatusRepository>;
export function useDealStatusRepository(): DealStatusRepositoryClient { return makeRepositoryProxy<DealStatusRepositoryClient>('crm::DealStatusRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useDealStatusRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const dealStatusRepository = useDealStatusRepository();

type DealVersionRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<DealVersionRepository>;
export function useDealVersionRepository(): DealVersionRepositoryClient { return makeRepositoryProxy<DealVersionRepositoryClient>('crm::DealVersionRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useDealVersionRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const dealVersionRepository = useDealVersionRepository();

type DealRowRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<DealRowRepository>;
export function useDealRowRepository(): DealRowRepositoryClient { return makeRepositoryProxy<DealRowRepositoryClient>('crm::DealRowRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useDealRowRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const dealRowRepository = useDealRowRepository();

type DealRowQuoteRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<DealRowQuoteRepository>;
export function useDealRowQuoteRepository(): DealRowQuoteRepositoryClient { return makeRepositoryProxy<DealRowQuoteRepositoryClient>('crm::DealRowQuoteRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useDealRowQuoteRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const dealRowQuoteRepository = useDealRowQuoteRepository();

type WorkOrderRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<WorkOrderRepository>;
export function useWorkOrderRepository(): WorkOrderRepositoryClient { return makeRepositoryProxy<WorkOrderRepositoryClient>('crm::WorkOrderRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useWorkOrderRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const workOrderRepository = useWorkOrderRepository();

type DealEventRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<DealEventRepository>;
export function useDealEventRepository(): DealEventRepositoryClient { return makeRepositoryProxy<DealEventRepositoryClient>('crm::DealEventRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useDealEventRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const dealEventRepository = useDealEventRepository();

type SalesAreaRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<SalesAreaRepository>;
export function useSalesAreaRepository(): SalesAreaRepositoryClient { return makeRepositoryProxy<SalesAreaRepositoryClient>('crm::SalesAreaRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useSalesAreaRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const salesAreaRepository = useSalesAreaRepository();

type SegmentRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<SegmentRepository>;
export function useSegmentRepository(): SegmentRepositoryClient { return makeRepositoryProxy<SegmentRepositoryClient>('crm::SegmentRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useSegmentRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const segmentRepository = useSegmentRepository();

type TagRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<TagRepository>;
export function useTagRepository(): TagRepositoryClient { return makeRepositoryProxy<TagRepositoryClient>('crm::TagRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useTagRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const tagRepository = useTagRepository();

type SalesPlanRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<SalesPlanRepository>;
export function useSalesPlanRepository(): SalesPlanRepositoryClient { return makeRepositoryProxy<SalesPlanRepositoryClient>('crm::SalesPlanRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useSalesPlanRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const salesPlanRepository = useSalesPlanRepository();

type SalesPlanItemRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<SalesPlanItemRepository>;
export function useSalesPlanItemRepository(): SalesPlanItemRepositoryClient { return makeRepositoryProxy<SalesPlanItemRepositoryClient>('crm::SalesPlanItemRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useSalesPlanItemRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const salesPlanItemRepository = useSalesPlanItemRepository();

type DealTypeAttributeRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<DealTypeAttributeRepository>;
export function useDealTypeAttributeRepository(): DealTypeAttributeRepositoryClient { return makeRepositoryProxy<DealTypeAttributeRepositoryClient>('crm::DealTypeAttributeRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useDealTypeAttributeRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const dealTypeAttributeRepository = useDealTypeAttributeRepository();

type DealTypeAttributeOptionRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<DealTypeAttributeOptionRepository>;
export function useDealTypeAttributeOptionRepository(): DealTypeAttributeOptionRepositoryClient { return makeRepositoryProxy<DealTypeAttributeOptionRepositoryClient>('crm::DealTypeAttributeOptionRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useDealTypeAttributeOptionRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const dealTypeAttributeOptionRepository = useDealTypeAttributeOptionRepository();

type DealAttributeValueRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<DealAttributeValueRepository>;
export function useDealAttributeValueRepository(): DealAttributeValueRepositoryClient { return makeRepositoryProxy<DealAttributeValueRepositoryClient>('crm::DealAttributeValueRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useDealAttributeValueRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const dealAttributeValueRepository = useDealAttributeValueRepository();

type LeadTypeAttributeRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<LeadTypeAttributeRepository>;
export function useLeadTypeAttributeRepository(): LeadTypeAttributeRepositoryClient { return makeRepositoryProxy<LeadTypeAttributeRepositoryClient>('crm::LeadTypeAttributeRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useLeadTypeAttributeRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const leadTypeAttributeRepository = useLeadTypeAttributeRepository();

type LeadTypeAttributeOptionRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<LeadTypeAttributeOptionRepository>;
export function useLeadTypeAttributeOptionRepository(): LeadTypeAttributeOptionRepositoryClient { return makeRepositoryProxy<LeadTypeAttributeOptionRepositoryClient>('crm::LeadTypeAttributeOptionRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useLeadTypeAttributeOptionRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const leadTypeAttributeOptionRepository = useLeadTypeAttributeOptionRepository();

type LeadAttributeValueRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<LeadAttributeValueRepository>;
export function useLeadAttributeValueRepository(): LeadAttributeValueRepositoryClient { return makeRepositoryProxy<LeadAttributeValueRepositoryClient>('crm::LeadAttributeValueRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useLeadAttributeValueRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const leadAttributeValueRepository = useLeadAttributeValueRepository();

type PartnerStatusRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<PartnerStatusRepository>;
export function usePartnerStatusRepository(): PartnerStatusRepositoryClient { return makeRepositoryProxy<PartnerStatusRepositoryClient>('crm::PartnerStatusRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте usePartnerStatusRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const partnerStatusRepository = usePartnerStatusRepository();

type LeadSourceRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<LeadSourceRepository>;
export function useLeadSourceRepository(): LeadSourceRepositoryClient { return makeRepositoryProxy<LeadSourceRepositoryClient>('crm::LeadSourceRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useLeadSourceRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const leadSourceRepository = useLeadSourceRepository();

type LostReasonRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<LostReasonRepository>;
export function useLostReasonRepository(): LostReasonRepositoryClient { return makeRepositoryProxy<LostReasonRepositoryClient>('crm::LostReasonRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useLostReasonRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const lostReasonRepository = useLostReasonRepository();

type CrmTaskRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<CrmTaskRepository>;
export function useCrmTaskRepository(): CrmTaskRepositoryClient { return makeRepositoryProxy<CrmTaskRepositoryClient>('crm::CrmTaskRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useCrmTaskRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const crmTaskRepository = useCrmTaskRepository();

type searchCompanyType = typeof import('../server/functions/searchCompany').searchCompany;
export const searchCompany: RpcFunctionClient<searchCompanyType> = makeFunctionProxy<searchCompanyType>('crm::searchCompany');

type getCompanyByInnType = typeof import('../server/functions/getCompanyByInn').getCompanyByInn;
export const getCompanyByInn: RpcFunctionClient<getCompanyByInnType> = makeFunctionProxy<getCompanyByInnType>('crm::getCompanyByInn');

type getSalesSummaryType = typeof import('../widgets/sales-summary/server/getSalesSummary').getSalesSummary;
export const getSalesSummary: RpcFunctionClient<getSalesSummaryType> = makeFunctionProxy<getSalesSummaryType>('crm::getSalesSummary');

type getSalesTrendType = typeof import('../widgets/sales-trend/server/getSalesTrend').getSalesTrend;
export const getSalesTrend: RpcFunctionClient<getSalesTrendType> = makeFunctionProxy<getSalesTrendType>('crm::getSalesTrend');

type getLeadFunnelType = typeof import('../widgets/lead-funnel/server/getLeadFunnel').getLeadFunnel;
export const getLeadFunnel: RpcFunctionClient<getLeadFunnelType> = makeFunctionProxy<getLeadFunnelType>('crm::getLeadFunnel');

type getSalesSummaryDefaultsType = typeof import('../widgets/sales-summary/server/getSalesSummaryDefaults').getSalesSummaryDefaults;
export const getSalesSummaryDefaults: RpcFunctionClient<getSalesSummaryDefaultsType> = makeFunctionProxy<getSalesSummaryDefaultsType>('crm::getSalesSummaryDefaults');

type detachDealDocumentsType = typeof import('../server/functions/detachDealDocuments').detachDealDocuments;
export const detachDealDocuments: RpcFunctionClient<detachDealDocumentsType> = makeFunctionProxy<detachDealDocumentsType>('crm::detachDealDocuments');

type activityBackfillScanCandidatesType = typeof import('../server/functions/activityBackfillScanCandidates').activityBackfillScanCandidates;
export const activityBackfillScanCandidates: RpcFunctionClient<activityBackfillScanCandidatesType> = makeFunctionProxy<activityBackfillScanCandidatesType>('crm::activityBackfillScanCandidates');

type activityBackfillPreviewType = typeof import('../server/functions/activityBackfillPreview').activityBackfillPreview;
export const activityBackfillPreview: RpcFunctionClient<activityBackfillPreviewType> = makeFunctionProxy<activityBackfillPreviewType>('crm::activityBackfillPreview');

type activityBackfillExecuteType = typeof import('../server/functions/activityBackfillExecute').activityBackfillExecute;
export const activityBackfillExecute: RpcFunctionClient<activityBackfillExecuteType> = makeFunctionProxy<activityBackfillExecuteType>('crm::activityBackfillExecute');

type activityBackfillExecuteBatchType = typeof import('../server/functions/activityBackfillExecuteBatch').activityBackfillExecuteBatch;
export const activityBackfillExecuteBatch: RpcFunctionClient<activityBackfillExecuteBatchType> = makeFunctionProxy<activityBackfillExecuteBatchType>('crm::activityBackfillExecuteBatch');
